import axios from "axios";
import {authtoken} from '@/values/private';

export default {
  namespaced: true,
  state: {
    companies: [],
    images: [],
    isReceiving: false,
    isUpdating: false,
    isDeleting: false,
    idToDelete: null,
    companiesMessage: ''
  },
  mutations: {
    RECEIVED_COMPANIES(state, payload) {
      state.companies = payload;
      state.isReceiving = false;
    },
    RECEIVING_COMPANIES(state) {
      state.isReceiving = true;
    },
    RECEIVED_COMPANY(state, payload) {
      state = Object.assign(state, {
        companies: [...state.companies, payload],
        isReceiving: false,
      })
    },
    RECEIVING_COMPANY(state) {
      state.isReceiving = true;
    },
    UPDATED_COMPANY(state, payload) {
      let index = state.companies.findIndex(company => company._id === payload._id);
      state = Object.assign(state, {
        companies: state.companies.map((company, i) => {
          if (i === index) {
            return Object.assign({}, company, payload);
          }
          return company;
        }),
        isUpdating: false,
        companiesMessage: 'Companies has been updating!',
      })
    },
    UPDATING_COMPANY(state) {
      state.isUpdating = true;
    },
    DELETED_COMPANY(state, payload) {
      let indexToDelete = state.companies.findIndex(company => company._id === payload._id);
      let companies = [...state.companies];
      companies.splice(indexToDelete, 1);
      state = Object.assign(state, {
        companies: [...companies],
        isDeleting: false,
        idToDelete: null,
        companiesMessage: 'Company has been Deleted!',
      });
    },
    DELETING_COMPANY(state, payload) {
      state.isDeleting = true;
      state.idToDelete = payload.id;
    },
  },
  actions: {
    getCompaniesRequest({dispatch}) {
      dispatch("receivingCompanies");
      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/get/companies';
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      axios({method: "GET", url: url, headers: headers})
      .then(res => {
        dispatch("receiveCompanies", res.data);
      })
    },
    async getCompaniesByTokenRequest({dispatch}) {
      dispatch("receivingCompanies");
      let url = 'https://api.accountxc.com:3100/get/companies/token';
      let headers = {'Content-Type': 'application/json','authtoken': authtoken};
      let response = await axios({method: "GET", url: url, headers: headers})
      dispatch("receiveCompanies", response.data);
      return response.data;
    },
    updateCompanyRequest({dispatch}, payload) {
      dispatch("updatingCompany");
      let id = payload._id;
      delete payload['_id'];

      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/update/company/' + id;
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};

      axios({method: "PUT",url: url,headers: headers,data: payload})
      .then(function (res) {
        dispatch("updateCompany", res.data);
      })
      .catch((error) => {
        console.error('Error:', error);
        this.alertmessage = error;
      });
    },
    updateCompanyImageRequest({dispatch}, payload) {
      dispatch("updatingCompany");
      let token = localStorage.getItem('token');
      let id = payload._id;
      delete payload['_id'];

      var url = 'https://api.accountxc.com:3100/update/company/image/' + id;
      let data = new FormData();
      data.append('image', payload.companyimage, payload.imagename); 
      delete payload['companyimage'];
      for (let x in payload) {data.append(x, payload[x]);}
      let headers = {'Content-Type': 'multipart/form-data','Authorization': 'Bearer ' + token};
      axios({method: "PUT", url: url,headers: headers,data: data})
      .then(function (res) {
        dispatch("updateCompany", res.data);
      })
      .catch((error) => {
        console.error('Error:', error);
        this.alertmessage = error;
      });
    },
    async insertCompanyRequest({dispatch}, payload) {
      dispatch("receivingCompanies");
      let token = localStorage.getItem('token');
      console.log(token)
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      let url = 'https://api.accountxc.com:3100/insert/company';
      let data = payload;
      console.log(payload)
      await axios({method: "POST", url: url, headers: headers, data: data})
      .then((response)=>{
        dispatch("receiveCompany", response.data);
      })
      .catch((error) => {
        this.alertmessage = error;
      });	
    },
    deleteCompanyRequest({dispatch}, payload) {
      dispatch("deletingCompany", payload);
      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/delete/company/' + payload._id
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      axios({method: "DELETE", url: url, headers: headers}).then(() => {
        dispatch("deleteCompany", {_id: payload._id});
      })
    },
    receiveCompanies({commit}, payload) {
      commit("RECEIVED_COMPANIES", payload)
    },
    receivingCompanies({commit}) {
      commit("RECEIVING_COMPANIES")
    },
    receiveCompany({commit}, payload) {
      commit("RECEIVED_COMPANY", payload)
    },
    receivingCompany({commit}) {
      commit("RECEIVING_COMPANY")
    },
    updateCompany({commit}, payload) {
      commit("UPDATED_COMPANY", payload)
    },
    updatingCompany({commit}) {
      commit("UPDATING_COMPANY")
    },
    deleteCompany({commit}, payload) {
      commit("DELETED_COMPANY", payload)
    },
    deletingCompany({commit}, payload) {
      commit("DELETING_COMPANY", payload)
    }
  },
};
